import { useState, useRef, useEffect } from "react";

export const useInput = (name, initialValue = null) => {

    const ref = useRef(null);
    const changeCount = useRef(1);
    const initialValueRef = useRef(initialValue);

    const [ignore, setIgnore] = useState(false);
    const [value, setValue] = useState(initialValue);

    const [error, setError] = useState(false);
    const [errorVisible, setErrorVisible] = useState(false);

    useEffect(() => {
        if (!isSameValue(initialValueRef.current, initialValue)) {
            setValue(currentValue => (isSameValue(currentValue, initialValue) ? currentValue : initialValue));
            initialValueRef.current = initialValue;
        }
    }, [initialValue]);

    const isSameValue = (v1, v2) => {
        if (Object.is(v1, v2)) {
            return true;
        }
        const v1IsObject = typeof v1 === "object" && v1 !== null;
        const v2IsObject = typeof v2 === "object" && v2 !== null;
        if (!v1IsObject || !v2IsObject) {
            return false;
        }
        try {
            return JSON.stringify(v1) === JSON.stringify(v2);
        } catch {
            return false;
        }
    };

    const set = (val, ignore) => {
        setValue(val);
        setIgnore(ignore ?? false);
        changeCount.current += 1;
    };

    const focus = () => ref.current.focus();

    const onChange = value => set(value);

    return {
        ref,
        name,
        value,
        ignore,
        changeCount: changeCount.current,
        set,
        focus,
        setError,
        setErrorVisible,
        bind: {
            ref,
            name,
            value,
            error,
            errorVisible,
            onChange,
        }
    };
};
